import './App.css';
import Color from './components/Color';
import Counter from './components/Counter';
import Ocount from './components/Ocount';
import { useCreateDataMutation, useDeleteDataMutation, useGetAlldataQuery, useUpdateDataMutation } from './components/apiData';

function App() {

  // let ad
  const [createData, responseInfo] = useCreateDataMutation()
  const [deleteData, deleteInfo]= useDeleteDataMutation()
  const [updateData, updateInfo] = useUpdateDataMutation()
  const info = useGetAlldataQuery()
  
  // const {data} = info
  if(info.isLoading) return <div>
    Loading
  </div>
  const handlesubmit= async (e)=>{
    e.preventDefault()
    const data = new FormData(e.currentTarget)
    const adata = {
      name:data.get("name"),
      age:data.get("age"),
      fee:data.get("fee")
    }
    await createData(adata)
    console.log("create"+responseInfo)
    window.location.reload(true)
  }
  
  const handleupdate=async (e)=>{
    const udata = new FormData(e.currentTarget)
    const audata = {
      id:udata.get("id"),
      name:udata.get("name"),
      age:udata.get("age"),
      fee:udata.get("fee")
    }
    await updateData(audata)
    console.log("update"+updateInfo)
    window.location.reload(true)
  }
  

  return (
    <div className="App">

      <h1>RT - State Management.</h1>
      <Counter/>
      <Ocount/>
      <Color/> <hr/>

      <h1>RKT Query</h1>

      <form onSubmit={handlesubmit} method="post" >
        <input type="text" name="name" placeholder='name' required />
        <input type="text" name="age" placeholder='age'required  />
        <input type="text" name="fee" placeholder='fee' required  />
        <button type='submit' >Add Student</button>
      </form>
      {
        info.data.map((p,i)=>{
          return (
            <>
            <div key={i}>
            <h4 >
              {p._id} {p.name} {p.age} {p.fee.$numberDecimal} 
              
              <form onClick={async (e)=> {
                e.preventDefault()
                await deleteData(p._id)
                console.log(deleteInfo)
                window.location.reload(true)
              } } method='post' >
                <button type="submit">Delete</button>
              </form>
          
            </h4>

           

            </div>
            
            </>
          )
          
          
        })
      }
       <form onSubmit={handleupdate} method="put" >
          <input type="text" name="id" placeholder='id' required />
          <input type="text" name="name" placeholder='name' required />
          <input type="text" name="age" placeholder='age'required  />
          <input type="text" name="fee" placeholder='fee' required  />
          <button type="submit" >Update Student</button>
        </form>  
      
    </div>
  );
}

export default App;
